/**
 * Check if arr1 contains all values from arr2
 */
const containsAll =
  <A>(arr1: A[]) =>
  (arr2: A[]): boolean =>
    arr2.every((item) => arr1.includes(item));

const equals =
  <A>(arr1: A[]) =>
  (arr2: A[]): boolean =>
    containsAll(arr1)(arr2) && containsAll(arr2)(arr1);

export const ipfArray = {
  containsAll,
  equals,
};
